import { render, staticRenderFns } from "./StudentAlertReason.vue?vue&type=template&id=4fedd1b9&"
import script from "./StudentAlertReason.vue?vue&type=script&lang=js&"
export * from "./StudentAlertReason.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4fedd1b9', component.options)
    } else {
      api.reload('4fedd1b9', component.options)
    }
    module.hot.accept("./StudentAlertReason.vue?vue&type=template&id=4fedd1b9&", function () {
      api.rerender('4fedd1b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/student-profile/components/alert/StudentAlertReason.vue"
export default component.exports